<template>
  <div class="eligibilities-list-toolbar">
    <v-divider />
    <v-toolbar flat>
      <v-toolbar-items>
        <v-menu offset-y v-if="!isInvited">
          <v-btn flat slot="activator">
            Select
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
          <v-card dark flat>
            <v-subheader>
              {{ selected.length }} {{ selected.length == 1 ? 'candidate' : 'candidates' }} selected
            </v-subheader>
            <v-list dark>
              <v-list-tile @click="selectAll" :disabled="allSelected">
                <v-list-tile-content>
                  <v-list-tile-title class="subheading">Select All</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action :style="allSelected ? 'opacity: 0.5;' : ''">
                  <v-icon>mdi-checkbox-multiple-marked-outline</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile @click="deselectAll" :disabled="!selected[0]">
                <v-list-tile-content>
                  <v-list-tile-title class="subheading">Deselect All</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action :style="!selected[0] ? 'opacity: 0.5;' : ''">
                  <v-icon>mdi-checkbox-multiple-blank-outline</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar-items>
      <v-spacer />

      <v-toolbar-items>
        <can I="edit" a="Eligibility">
          <v-menu
            v-if="!isInvited"
            :disabled="!selected[0]"
            v-model="inviting"
            left
            bottom
            max-width="200"
          >
            <v-tooltip slot="activator" bottom>
              <v-btn :disabled="!selected[0]" slot="activator" flat>
                Invite <v-icon right>mdi-email</v-icon>
              </v-btn>
              <span>Invite selected candidates</span>
            </v-tooltip>
            <v-card dark>
              <v-card-text>
                You are about to invite {{ selected.length }}
                candidates to apply for this opportunity.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="inviting = false">Cancel</v-btn>
                <v-btn @click="invite">Invite</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </can>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-menu offset-y>
          <v-tooltip slot="activator" bottom>
            <v-btn slot="activator" flat class="pr-1" style="min-width: 0px;">
              <span v-if="!iconsOnly">Sort by </span>
              <v-icon>{{ sortBy.icon }}</v-icon>
            </v-btn>
            <span>Sort candidates</span>
          </v-tooltip>
          <v-list dark>
            <v-list-tile
              @click="changeSortBy(sort)"
              v-for="(sort, i) in sortValues"
              :key="`sort-${i}`"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  <span class="caption">{{ sort.label }}</span>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon>{{ sort.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-tooltip bottom slot="activator">
          <v-btn
            slot="activator"
            flat
            @click="changeSortDirection"
            class="pl-1"
            style="min-width: 0px;"
          >
            <v-icon medium v-if="sortBy.desc" key="sort-asc">mdi-sort-descending</v-icon>
            <v-icon medium v-else key="sort-desc">mdi-sort-ascending</v-icon>
          </v-btn>
          <span>Change sorting direction</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn slot="activator" flat @click="filtering = !filtering">
            <span v-if="!iconsOnly">Filter</span>
            <v-icon :right="!iconsOnly" medium>mdi-filter</v-icon>
          </v-btn>
          <span>Set candidate filters</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <EligibilitiesFilter v-model="filtering" />
    <v-divider />
  </div>
</template>

<script>
// Components
import EligibilitiesFilter from '@/components/applications_tracker/eligibilities/EligibilitiesFilter'

export default {
  props: { eligibilities: Array, phase: Object },
  components: { EligibilitiesFilter },
  data() {
    return {
      inviting: false,
      filtering: false,
      sortBy: {
        value: 'profile.updatedAt',
        label: 'Sort by Last Update',
        icon: 'mdi-calendar',
        desc: false,
      },
      sortValues: [
        {
          value: 'completion',
          label: 'Sort by Completion',
          icon: 'mdi-timelapse',
          desc: true,
        },
        {
          value: 'profile.firstNames.sort',
          label: 'Sort by Name',
          icon: 'mdi-alphabetical',
          desc: false,
        },
        {
          value: 'profile.updatedAt',
          label: 'Sort by Last Update',
          icon: 'mdi-calendar',
          desc: false,
        },
      ],
    }
  },
  computed: {
    isInvited() {
      return this.phase.name === 'Invited'
    },

    opportunity() {
      return this.$store.getters['admin/opportunities/find']()
    },

    selected() {
      return this.$store.getters['admin/eligibilities/selected']
    },
    allSelected() {
      return (
        _.intersection(this.eligibilities.map(e => e.id), this.selected).length ===
        this.eligibilities.length
      )
    },
    iconsOnly() {
      return this.$vuetify.breakpoint.mdAndDown
    },
  },
  methods: {
    selectAll() {
      return this.$store.commit('admin/eligibilities/select', this.eligibilities.map(c => c.id))
    },
    deselectAll() {
      return this.$store.commit('admin/eligibilities/deselect', this.selected)
    },

    changeSortDirection() {
      this.sortBy.desc = !this.sortBy.desc
      this.$store.commit('admin/eligibilities/updateSort', {
        by: this.sortBy.value,
        descending: this.sortBy.desc,
      })
    },

    changeSortBy(by) {
      this.sortBy = by
      this.sortBy.desc = false
      this.$store.commit('admin/eligibilities/updateSort', { by: by.value, descending: false })
    },

    async invite() {
      this.$store.dispatch('snackbarShow', `Inviting candidates…`)
      await this.$store.dispatch('admin/eligibilities/invite', this.selected)
      this.$store.dispatch('snackbarSuccess', `Candidates invited!`)
      this.inviting = false
    },
  },
}
</script>
